import React from "react";
import PropTypes from "prop-types";
import AddressInputComponent from "./AddressInputComponent";
import PhoneInputComponent, {
    CHANNEL_VOICE,
    PROP_NAME_ENABLE_2FA,
    PROP_NAME_PHONE_COUNTRY_CODE,
    PROP_NAME_PHONE_NUMBER
} from "./PhoneInputComponent";
import UserDataService from "../../common/UserDataService";
import {setupOnExtractData} from "../../../util/FormUtil";

class WorkInfoInputComponent extends React.Component {

    constructor(props){
        super(props);
        this.setExtractAddressData = this.setExtractAddressData.bind(this);
        this.setExtractPhoneData = this.setExtractPhoneData.bind(this);
        this.extractData = this.extractData.bind(this);
    }

    componentDidMount() {
        setupOnExtractData(this);
    }

    extractData(){
        const {allowSkipPhoneInput} = this.props;
        const addressInfo = this.extractAddressData();
        const phoneInfo = allowSkipPhoneInput ? this.buildTempPhoneData() : this.extractPhoneData();
        return {addressInfo, phoneInfo};
    }

    /*
     * AREAAA-793: Build a phone info object with placeholder value so that the data passed to backend won't cause
     * Spring binding error. The values in this object should be ignored by the backend and replaced with the user's
     * actual phone data from DUO.
     */
    buildTempPhoneData(){
        const result = {};
        result[PROP_NAME_PHONE_COUNTRY_CODE] = "1";
        result[PROP_NAME_PHONE_NUMBER] = "123";
        result[PROP_NAME_ENABLE_2FA] = "Y";
        result.twoFactorChannel = CHANNEL_VOICE;
        return result;
    }

    setExtractPhoneData(func){
        this.extractPhoneData = func;
    }

    setExtractAddressData(func){
        this.extractAddressData = func;
    }

    render(){
        const {data, disableVoiceOption = false, metadata, readOnlyAddress, userDataService, setFormState, userDataInit,
            phoneRequired = true, smsOnly = false, countryCodeWidth, allowSkipPhoneInput, onError,skipIpStackServiceCall} = this.props;

        return (
            <div>
                <AddressInputComponent
                    data={data}
                    metadata={metadata}
                    userDataService={userDataService}
                    readOnly={readOnlyAddress}
                    setFormState={setFormState}
                    userDataInit={userDataInit}
                    onExtractData={this.setExtractAddressData}
                    skipIpStackServiceCall={skipIpStackServiceCall}
                />

                {
                    !allowSkipPhoneInput &&
                    <PhoneInputComponent
                        data={data}
                        disableVoiceOption={disableVoiceOption}
                        metadata={metadata}
                        setFormState={setFormState}
                        userDataInit={userDataInit}
                        userDataService={userDataService}
                        onExtractData={this.setExtractPhoneData}
                        required={phoneRequired}
                        smsOnly={smsOnly}
                        countryCodeWidth={countryCodeWidth}
                        onError={onError}
                    />
                }
            </div>
        );
    }
}

WorkInfoInputComponent.propTypes = {
    countryCodeWidth: PropTypes.string,
    data: PropTypes.object.isRequired,
    disableVoiceOption: PropTypes.bool,
    metadata: PropTypes.object.isRequired,
    userDataService: PropTypes.instanceOf(UserDataService).isRequired,
    readOnlyAddress: PropTypes.object,
    setFormState: PropTypes.func.isRequired,
    userDataInit: PropTypes.object.isRequired,
    onExtractData: PropTypes.func,
    phoneRequired: PropTypes.bool,
    allowSkipPhoneInput: PropTypes.bool,
    onError: PropTypes.func.isRequired
};

export default WorkInfoInputComponent;